export default "__VITE_ASSET__01df97c7__"